import * as React from "react";
import { SVGProps } from "react";
const SvgQuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.6 24.65c1.275 0 2.225-.9 2.225-2.1 0-1.225-.95-2.125-2.225-2.125-1.3 0-2.225.9-2.225 2.125 0 1.2.925 2.1 2.225 2.1Zm.15-17.3c-3.475 0-4.8 2.025-4.8 4.15l3.4.375c0-.575.4-1.3 1.625-1.3 1 0 1.525.575 1.525 1.35 0 2.175-3.725 3.05-3.725 6.775h3.6c0-2.575 3.675-3.375 3.675-6.85 0-2.5-1.825-4.5-5.3-4.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuestionMark;
